<div class="content">
  @if (isLockedOut) {
  <div class="lockedOutSection" data-test-id="sign-in-locked-out-section">
    <p class="messageTitle">Oops! Something went wrong.</p>
    <p class="messageText">
      Too many failed login attempts. Please try again in
      {{ minutesLeftMessage() }} or
      <a
        class="forgot-password-inline-link"
        routerLink="/forgot-password"
        data-test-id="sign-in-forgot-password"
      >
        reset your password
      </a>
      now.
    </p>
  </div>
  } @else {
  <form class="form" data-test-id="sign-in-form" (submit)="submit($event)">
    <app-text
      [size]="TextSize.TITLE_3"
      [height]="TextHeight.TITLE_4"
      [weight]="TextWeight.BOLD"
      [color]="TextColor.NEUTRAL_8"
      [spacingBottom]="Spacing.SMALL"
      [align]="TextAlign.CENTER"
    >
      Welcome!
    </app-text>
    <app-text
      [size]="TextSize.BODY_2"
      [height]="TextHeight.BODY_2"
      [weight]="TextWeight.REGULAR"
      [color]="TextColor.NEUTRAL_6"
      [spacingBottom]="Spacing.LARGE"
    >
      Log in with your Aaptiv credentials to access your Admin account
    </app-text>
    <app-text-input
      class="field"
      [(value)]="email"
      [type]="InputType.EMAIL"
      placeholder="{{ 'common.email' | translate }}"
      [error]="emailError"
      errorMessage="{{ emailErrorMessage }}"
      [size]="InputSize.LARGE"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.VERTICAL"
      [spacingBottom]="24"
      data-test-id="sign-in-email-input"
    ></app-text-input>
    <app-text-input
      class="field"
      [(value)]="password"
      [type]="InputType.PASSWORD"
      placeholder="{{ 'common.password' | translate }}"
      [error]="passwordError"
      errorMessage="{{ passwordErrorMessage }}"
      [size]="InputSize.LARGE"
      [width]="InputWidth.FULL"
      [direction]="InputDirection.VERTICAL"
      [spacingBottom]="32"
      data-test-id="sign-in-password-input"
    ></app-text-input>
    @if (invalidCredentials) {
    <p
      class="invalidCredentials"
      data-test-id="sign-in-invalid-credentials-message"
    >
      {{ invalidCredentialsMessage }}
    </p>
    }
    <app-view
      [direction]="ViewDirection.COLUMN"
      [gap]="Spacing.LARGE"
      [align]="ViewAlign.CENTER"
    >
      <app-button
        [type]="ButtonType.PRIMARY"
        [nativeType]="NativeButtonType.SUBMIT"
        [size]="ButtonSize.LARGE"
        [spacingBottom]="Spacing.NONE"
        data-test-id="sign-in-login-button"
      >
        {{ 'common.login' | translate }}
      </app-button>
      <a
        class="form-link"
        routerLink="/forgot-password"
        data-test-id="sign-in-forgot-password-link"
      >
        Forgot Password?
      </a>
    </app-view>
  </form>
  }
  <app-toast [position]="ToastPosition.FORM"></app-toast>
</div>
